export default {
  filterData : {
    Products: {
      label: 'Productos',
      allFilterLabel: "Todos los productos",
      items: [
        { name: "Citrix ADC", id: "citrix_adc" },
        { name: "Citrix Analytics for Performance", id: "citrix_analytics_for_performance" },
        { name: "Citrix Analytics for Security", id: "citrix_analytics_for_security" },     
        { name: "Citrix App Delivery and Security Service", id:"citrix_app_delivery_and_security_service"},
        { name: "Citrix Application Delivery Management", id: "citrix_application_delivery_management" },
        { name: "Citrix Content Collaboration", id: "citrix_content_collaboration" },
        { name: "Citrix DaaS (formerly Citrix Virtual Apps and Desktops service)", id: "citrix_virtual_apps_and_desktops" },
        {
          name: "Citrix DaaS Standard for Azure",
          id: "citrix_virtual_apps_and_desktops_standard_for_azure"
        },
        {
          name: "Citrix DaaS Standard for Google Cloud",
          id: "citrix_daas_standard_for_google_cloud",
        },
        { name: "Citrix Endpoint Management", id: "citrix_endpoint_management" },
        { name: "Citrix Gateway", id: "citrix_gateway" },
        { name: "Citrix SD-WAN", id: "citrix_sd_wan" },
        { name: "Citrix Secure Internet Access", id: "citrix_secure_internet_access" },
        { name: "Citrix Secure Private Access", id: "citrix_secure_private_access" },
        { name: "Citrix Virtual Apps and Desktops", id: "citrix_virtual_apps_desktops" },
        { name: "Citrix Web App and API Protection", id: "citrix_web_app_and_api_protection" },
        { name: "Citrix Workspace", id: "citrix_workspace" },
      ],
    },
    Topics: {
      label: "Temas",
      allFilterLabel: "Todas los temas",
      items: [
        { name: "Administración de accesos", id: "Access management" },
        { name: "Análisis y supervisión", id: "Analytics and monitoring" },
        { name: "Entrega y seguridad de aplicaciones", id: "Application delivery and security" },
        { name: "Citrix y Google", id: "Citrix and Google" },
        { name: "Citrix y Microsoft", id: "Citrix and Microsoft" },
        { name: "Migración a la nube", id: "Cloud migration" },
        { name: "Comparar", id: "Compare" },
        { name: "Colaboración en contenidos", id: "Content collaboration" },
        { name: "Espacios de trabajo digitales", id: "Digital workspaces" },
        { name: "Experiencia de los empleados", id: "Employee experience" },
        { name: "Nube híbrida", id: "Hybrid cloud" },
        { name: "Trabajo híbrido", id: "Hybrid work" },
        { name: "Administrar y optimizar", id: "Manage and optimize" },
        { name: "Microservicios y devOps", id: "Microservices and devOps" },
        { name: "Incorporación y adopción", id: "Onboarding and adoption" },
        { name: "Integraciones de socios", id: "Partner integrations" },
        { name: "Información general del producto", id: "Product overview" },
        { name: "Seguridad y cumplimiento normativo", id: "Security and compliance" },
        { name: "Pequeñas empresas", id: "Small business" },
        { name: "Especificaciones", id: "Specifications" },
        { name: "Sostenibilidad", id: "Sustainability" },
        { name: "Administración unificada de terminales", id: "Unified endpoint management" },
        { name: "Virtualización de escritorios (VDI) y DaaS", id: "VDI and DaaS" },
      ],
    }, 
    Type: {
      label: 'Tipo',
      allFilterLabel: "Todos los tipos",
      items: [
        { name: "Informe de los analistas", id: "Analyst report" },
        { name: "Herramienta de evaluación", id: "Assessment tool" },
        { name: "Historia de un cliente", id: "Customer story" },
        { name: "Hoja de datos", id: "Data sheet" },
        { name: "Demo", id: "Demo" },
        { name: "Libro electrónico", id: "eBook" },
        { name: "Guía", id: "Guide" },
        { name: "Infografía", id: "Infographic" },
        { name: "Visita interactiva", id: "Interactive tour" },
        { name: "Podcast", id: "Podcast" },
        { name: "Kit de recursos", id: "Resource kit" },
        { name: "Informe de la solución", id: "Solution brief" },
        { name: "Información técnica", id: "Technical brief" },
        { name: "Vídeo", id: "Video" },
        { name: "Seminario web", id: "Webinar" },
        { name: "White paper", id: "White paper" },
      ],
    },
    Industry: {
      label: "Industria",
      allFilterLabel: "Todos los sectores",
      items: [
        { name: "Educación", id: "education" },
        { name: "Servicio financiero", id: "financial_service" },
        { name: "Gobierno", id: "government" },
        { name: "Sector de la salud", id: "healthcare" },
        { name: "Sector de fabricación", id: "manufacturing" },
        { name: "Venta minorista", id: "retail" }
      ],
    }
  },
    searchPlaceholder: "Buscar biblioteca",
    titles : {
      label1: "Tendencia actual",
      label2: "Últimos recursos",
      label3: "Vistos recientemente",
      label4: "Recursos recomendados"
    },
    showMoreLabel: "Mostrar más",
    clearAllSelected: "Borrar toda la selección",
    searchResults: "Resultados de la búsqueda para",
    clearAllFilters: "Eliminar todos los filtros",
    noResultsFound: "Ningún activo cumple los criterios seleccionados",
    resetView: "Restablecer vista",
    filterLabel: "Filtrar",
    filteredRes: "Resultados filtrados",
    filterRes: "Filtrar resultados",
    clearAllCta: "Borrar todo",
    applyCta: "Aplicar",
    view: "Ver",
    includeEnglishRes: "Incluir recursos en inglés"
  };
